export enum TurnstileType {
  Cloudflare = 'cloudflare',
  HCaptcha = 'hcaptcha',
}

export interface ITurnstileVerifyPayload {
  token: string;
  type: TurnstileType;
}
